var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticStyle:{"margin-top":"8px"},attrs:{"total":_vm.total,"current-page":_vm.page + 1,"page-size":_vm.size,"page-sizes":[10, 20, 50],"layout":"total, prev, pager, next, sizes"},on:{"size-change":function($event){return _vm.$emit('size-change', $event)},"current-change":function($event){return _vm.$emit('page-change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }